/*!
 * FilePondPluginPdfPreview 1.0.4
 * Licensed under MIT, https://opensource.org/licenses/MIT/
 * Please visit https://github.com/Adri-Glez/filepond-plugin-pdf-preview#readme for details.
 */

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() : typeof define === 'function' && define.amd ? define(factory) : (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.FilePondPluginPdfPreview = factory());
})(this, function () {
  'use strict';

  var isPreviewablePdf = function isPreviewablePdf(file) {
    return /pdf$/.test(file.type);
  };
  var createPdfView = function createPdfView(_) {
    return _.utils.createView({
      name: 'pdf-preview',
      tag: 'div',
      ignoreRect: true,
      create: function create(_ref) {
        var root = _ref.root,
          props = _ref.props;
        // get item
        var item = root.query('GET_ITEM', {
          id: props.id
        });
        if (isPreviewablePdf(item.file)) {
          var numPdfPreviewHeight = root.query('GET_PDF_PREVIEW_HEIGHT');
          root.ref.pdf = document.createElement('object');
          root.ref.pdf.setAttribute('height', numPdfPreviewHeight);
          root.ref.pdf.setAttribute('width', '100%'); //320
          root.ref.pdf.setAttribute('style', 'position:absolute;left:0;right:0;margin:auto;padding-top:unset;' + (numPdfPreviewHeight ? 'height:' + numPdfPreviewHeight + 'px;' : ''));
          root.element.appendChild(root.ref.pdf);
        }
      },
      write: _.utils.createRoute({
        DID_PDF_PREVIEW_LOAD: function DID_PDF_PREVIEW_LOAD(_ref2) {
          var root = _ref2.root,
            props = _ref2.props;
          var id = props.id;

          // get item
          var item = root.query('GET_ITEM', {
            id: id
          });
          if (!item) return;
          var URL = window.URL || window.webkitURL;
          var blob = new Blob([item.file], {
            type: item.file.type
          });
          root.ref.pdf.type = item.file.type;
          if (isPreviewablePdf(item.file)) {
            var sPdfComponentExtraParams = root.query('GET_PDF_COMPONENT_EXTRA_PARAMS');
            root.ref.pdf.data = URL.createObjectURL(blob) + (!sPdfComponentExtraParams ? '' : '#?' + sPdfComponentExtraParams);
          }
          //else root.ref.pdf.src = URL.createObjectURL(blob);

          root.ref.pdf.addEventListener('load', function () {
            if (isPreviewablePdf(item.file)) {
              root.dispatch('DID_UPDATE_PANEL_HEIGHT', {
                id: id,
                height: root.ref.pdf.scrollHeight
              });
            }
          }, false);
        }
      })
    });
  };
  var SVG_MASK = '<svg width="500" height="200" viewBox="0 0 500 200" preserveAspectRatio="none">\n    <defs>\n        <radialGradient id="gradient-__UID__" cx=".5" cy="1.25" r="1.15">\n            <stop offset=\'50%\' stop-color=\'#000000\'/>\n            <stop offset=\'56%\' stop-color=\'#0a0a0a\'/>\n            <stop offset=\'63%\' stop-color=\'#262626\'/>\n            <stop offset=\'69%\' stop-color=\'#4f4f4f\'/>\n            <stop offset=\'75%\' stop-color=\'#808080\'/>\n            <stop offset=\'81%\' stop-color=\'#b1b1b1\'/>\n            <stop offset=\'88%\' stop-color=\'#dadada\'/>\n            <stop offset=\'94%\' stop-color=\'#f6f6f6\'/>\n            <stop offset=\'100%\' stop-color=\'#ffffff\'/>\n        </radialGradient>\n        <mask id="mask-__UID__">\n            <rect x="0" y="0" width="500" height="200" fill="url(#gradient-__UID__)"></rect>\n        </mask>\n    </defs>\n    <rect x="0" width="500" height="200" fill="currentColor" mask="url(#mask-__UID__)"></rect>\n</svg>';
  var SVGMaskUniqueId = 0;
  var createPdfOverlayView = function createPdfOverlayView(fpAPI) {
    return fpAPI.utils.createView({
      name: 'pdf-preview-overlay',
      tag: 'div',
      ignoreRect: true,
      create: function create(_ref) {
        var root = _ref.root,
          props = _ref.props;
        var mask = SVG_MASK;
        if (document.querySelector('base')) {
          var url = new URL(window.location.href.replace(window.location.hash, '')).href;
          mask = mask.replace(/url\(\#/g, 'url(' + url + '#');
        }
        SVGMaskUniqueId++;
        root.element.classList.add('filepond--pdf-preview-overlay-'.concat(props.status));
        root.element.innerHTML = mask.replace(/__UID__/g, SVGMaskUniqueId);
      },
      mixins: {
        styles: ['opacity'],
        animations: {
          opacity: {
            type: 'spring',
            mass: 25
          }
        }
      }
    });
  };
  var createPdfWrapperView = function createPdfWrapperView(_) {
    /**
     * Write handler for when preview container has been created
     */
    var didCreatePreviewContainer = function didCreatePreviewContainer(_ref) {
      var root = _ref.root,
        props = _ref.props;
      var id = props.id;
      var item = root.query('GET_ITEM', id);
      if (!item) return;

      // the preview is now ready to be drawn
      root.dispatch('DID_PDF_PREVIEW_LOAD', {
        id: id
      });
    };

    /**
     * Write handler for when the preview has been loaded
     */
    var restoreOverlay = function restoreOverlay(_ref2) {
      var root = _ref2.root;
      root.ref.overlayShadow.opacity = 1;
      root.ref.overlayError.opacity = 0;
      root.ref.overlaySuccess.opacity = 0;
    };
    var didThrowError = function didThrowError(_ref3) {
      var root = _ref3.root;
      root.ref.overlayShadow.opacity = 0.25;
      root.ref.overlayError.opacity = 1;
    };
    var didCompleteProcessing = function didCompleteProcessing(_ref4) {
      var root = _ref4.root;
      root.ref.overlayShadow.opacity = 0.25;
      root.ref.overlaySuccess.opacity = 1;
    };

    /**
     * Constructor
     */
    var create = function create(_ref5) {
      var root = _ref5.root,
        props = _ref5.props;
      // create overlay view
      var OverlayView = createPdfOverlayView(_);
      var pdf = createPdfView(_);

      // append pdf presenter
      root.ref.pdf = root.appendChildView(root.createChildView(pdf, {
        id: props.id
      }));

      // image overlays
      root.ref.overlayShadow = root.appendChildView(root.createChildView(OverlayView, {
        opacity: 0,
        status: 'idle'
      }));
      root.ref.overlaySuccess = root.appendChildView(root.createChildView(OverlayView, {
        opacity: 0,
        status: 'success'
      }));
      root.ref.overlayError = root.appendChildView(root.createChildView(OverlayView, {
        opacity: 0,
        status: 'failure'
      }));
    };
    return _.utils.createView({
      name: 'pdf-preview-wrapper',
      create: create,
      write: _.utils.createRoute({
        // pdf preview stated
        DID_PDF_PREVIEW_CONTAINER_CREATE: didCreatePreviewContainer,
        // file states
        DID_THROW_ITEM_LOAD_ERROR: didThrowError,
        DID_THROW_ITEM_PROCESSING_ERROR: didThrowError,
        DID_THROW_ITEM_INVALID: didThrowError,
        DID_COMPLETE_ITEM_PROCESSING: didCompleteProcessing,
        DID_START_ITEM_PROCESSING: restoreOverlay,
        DID_REVERT_ITEM_PROCESSING: restoreOverlay
      })
    });
  };

  /**
   * Pdf Preview Plugin
   */
  var plugin = function plugin(fpAPI) {
    var addFilter = fpAPI.addFilter,
      utils = fpAPI.utils;
    var Type = utils.Type,
      createRoute = utils.createRoute;
    var pdfWrapperView = createPdfWrapperView(fpAPI);

    // called for each view that is created right after the 'create' method
    addFilter('CREATE_VIEW', function (viewAPI) {
      // get reference to created view
      var is = viewAPI.is,
        view = viewAPI.view,
        query = viewAPI.query;

      // only hook up to item view
      if (!is('file')) {
        return;
      }

      // create the pdf preview plugin, but only do so if is a PDF
      var didLoadItem = function didLoadItem(_ref) {
        var root = _ref.root,
          props = _ref.props;
        var id = props.id;
        var item = query('GET_ITEM', id);
        if (!item || item.archived || !isPreviewablePdf(item.file)) {
          return;
        }

        // set preview view
        root.ref.pdfPreview = view.appendChildView(view.createChildView(pdfWrapperView, {
          id: id
        }));

        // now ready
        root.dispatch('DID_PDF_PREVIEW_CONTAINER_CREATE', {
          id: id
        });
      };

      // start writing
      view.registerWriter(createRoute({
        DID_LOAD_ITEM: didLoadItem
      }));
    });

    // expose plugin
    return {
      options: {
        allowPdfPreview: [true, Type.BOOLEAN],
        // Fixed PDF preview height
        pdfPreviewHeight: [320, Type.INT],
        // Extra params to pass to the pdf visualizer
        pdfComponentExtraParams: ['toolbar=0&navpanes=0&scrollbar=0&statusbar=0&zoom=0&messages=0&view=fitH&page=1', Type.STRING]
      }
    };
  };

  // fire pluginloaded event if running in browser, this allows registering the plugin when using async script tags
  var isBrowser = typeof window !== 'undefined' && typeof window.document !== 'undefined';
  if (isBrowser) {
    document.dispatchEvent(new CustomEvent('FilePond:pluginloaded', {
      detail: plugin
    }));
  }
  return plugin;
});